import { yupResolver } from "@hookform/resolvers/yup"
import React, { useState, useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Spinner,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  RichTextEditor,
  UFEditor,
  UFInput,
} from "../../../components/Common/Fields/Input"
import classnames from "classnames"
import closeIcon from "../../../assets/icons/close.svg"
import { Link } from "react-router-dom"
import {
  postTerms,
} from "../../../services/Inventory/inventory"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import Expense from "../../../components/Common/chooseFields/expense"
import TermsLi from "../../../components/Common/chooseFields/termsLi"
import draftToHtml from "draftjs-to-html"
import { ContentState, convertToRaw, EditorState } from "draft-js"
import htmlToDraft from "html-to-draftjs"

const schema = yup.object().shape({
//   description: yup.string().required("Description is Required"),
  // tag: yup.mixed().required("Expense Type is Required"),
  // badge: yup.string().required("Label is Required"),
})

const Edit = ({ loading, onUpdate, id, error, close, ...props }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    console.log("props?.editItem?.modal  :", props?.editItem?.value)
    if (props?.editItem?.modal) {
      reset({
        ...props?.editItem?.value,
        description: props?.editItem?.value?.description
          ? formatTemplate(props?.editItem?.value?.description)
          : "",
        category_id: props?.editItem?.value?.category_id
          ? {
              value: props?.editItem?.value?.category_id,
              label:
                props?.editItem?.value?.category_id == 1
                  ? "General"
                  : props?.editItem?.value?.category_id == 2
                  ? "Delivery"
                  : "Remarks",
            }
          : null,
        // tag: {
        //   label: props?.editItem?.value?.tag?.label,
        //   value: props?.editItem?.value?.tag?.id,
        //   id: props?.editItem?.value?.tag?.id,
        // },
      })
    }
  }, [props?.editItem?.modal])

  const formatTemplate = html => {
    let editorState = EditorState.createEmpty()
    if (html === null) {
      return editorState
    }
    const contentBlock = htmlToDraft(html)
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    )
    editorState = EditorState.createWithContent(contentState)
    return editorState
  }

  const handleSeriesAdd = async data => {
    const generalTerms = data?.description
      ? draftToHtml(convertToRaw(data?.description?.getCurrentContent()))
      : ""
    try {
      setIsLoading(true)
      const createdSeries = await postTerms({
        ...data,
        category_id: data?.category_id?.value,
        description: generalTerms,
      })
      toastSuccess(createdSeries?.message)
      onUpdate()
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      reset()
      close()
    }
  }

  return (
    <>
      <ModalHeader className="custom-modal-header">
        <div className="d-flex justify-content-between">
          <h5>{props?.editItem?.modal ? "Edit Terms" : "Add Terms"}</h5>{" "}
          <img
            src={closeIcon}
            alt=""
            onClick={close}
            width="10"
            role="button"
          />
        </div>
      </ModalHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="lg"
          />
        </div>
      ) : (
        <>
          <ModalBody>
            <FormProvider {...methods}>
              <Form id={`ev-form`} onSubmit={handleSubmit(handleSeriesAdd)}>
                <Row>
                  {/* <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Expense Type<span className="mandatory">*</span>
                      </Label>
                      <Expense
                        control={control}
                        name={"tag"}
                        disabled={props?.editItem?.modal ? true : false}
                      />
                      <FormFeedback invalid>{errors.tag?.message}</FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Label<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Label"
                        name={"badge"}
                        invalid={!!errors.badge}
                      />
                      <FormFeedback invalid>
                        {errors.badge?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col> */}
                  <Col lg={4} sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Terms
                        <span className="mandatory">*</span>
                      </Label>
                      <TermsLi
                        control={control}
                        name={"category_id"}

                        // onSelectChange={e => handleStatus(e)}
                      />
                      <FormFeedback invalid>
                        {errors.category_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Terms
                        <span className="mandatory">*</span>
                      </Label>
                      <RichTextEditor
                        control={control}
                        name={"description"}
                        invalid={!!errors.description}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                      />
                      <FormFeedback invalid>
                        {errors.description?.message}
                      </FormFeedback>
                    </FormGroup>
                    {/* <FormGroup className="mb-4">
                      <Label>
                        Series Description<span className="mandatory">*</span>
                      </Label>
                      <UFEditor
                        control={control}
                        placeholder="Enter the Series Description"
                        rows="3"
                        name={"description"}
                        invalid={!!errors.description}
                      />
                      <FormFeedback invalid>
                        {errors.description?.message}
                      </FormFeedback>
                    </FormGroup> */}
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </ModalBody>
          <ModalFooter>
            <LoadingButton
              form={`ev-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {props?.editItem?.modal ? "Update" : "Save"}
            </LoadingButton>
          </ModalFooter>
        </>
      )}
    </>
  )
}

const EditTerms = ({ buttonLabel, className, ...props }) => {
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  useEffect(() => {
    if (props?.editItem?.modal) {
      toggle()
    }
  }, [props?.editItem?.modal])

  return (
    <>
      <Link to="#" className={className} onClick={toggle}>
        {buttonLabel}
      </Link>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"} size="lg">
        <Edit
          close={() => {
            setModal(false)
            props?.onReset()
          }}
          {...props}
        />
      </Modal>
    </>
  )
}

export default EditTerms
